export class NavigationManager {
    private readonly apiSectionClass = 'opblock-tag';

    public apiSectionsLoaded(): boolean {
        return document.getElementsByClassName(this.apiSectionClass).length !== 0;
    }

    public enableScrolling(): void {
        document.body.style.overflowY = 'auto';
        document.body.style.height = 'auto';
    }
}
